module.exports = __webpack_public_path__ + "img/map-bailey.436d016c.png";